import { VisualizationType, VisualizationTypeOption } from '../models';

// TODO: Use constants for component names (DASHUI-8843)
export const getVisualizationType = (componentName: string): VisualizationTypeOption => {
  switch (componentName) {
    case 'editable:TimeSeries': {
      return VisualizationType.TIME_SERIES;
    }
    case 'editable:CategoricalBar': {
      return VisualizationType.CATEGORICAL_BAR;
    }
    case 'editable:StatusCardGroup': {
      return VisualizationType.STATUS_CARD_GROUP;
    }
    case 'editable:HeatGrid': {
      return VisualizationType.HEAT_GRID;
    }
    case 'editable:RatioBar': {
      return VisualizationType.RATIO_BAR;
    }
    default:
      return VisualizationType.OTHER;
  }
};
